<template>
	<div class="report-guide">
		<div class="banner">
			<img src="@/assets/home/img_sjgl_blzn_n@2x.png" alt="" class="bg-img">
		</div>
		<div class="tabs">
			<div class="tab-item" :class="{ active: activeTab === 'video' }" @click="activeTab = 'video'">
				视频指南
				<div class="indicator" v-if="activeTab === 'video'"></div>
			</div>
			<div class="tab-item" :class="{ active: activeTab === 'file' }" @click="activeTab = 'file'">
				文件指南
				<div class="indicator" v-if="activeTab === 'file'"></div>
			</div>
		</div>
		<div class="content-wrapper">
			<div v-if="activeTab === 'video'" class="video-list">
				<div v-for="(item, index) in videoList" :key="index" class="video-item" @click="playVideo(item)">
					<div class="video-cover">
						<video :src="item.videoUrl" class="preview-video" muted preload="metadata"></video>
						<div class="play-btn">
							<i class="el-icon-caret-right"></i>
						</div>
					</div>
					<div class="video-info">
						<span class="video-title">{{ item.title }}</span>
						<div class="more-actions" @click.stop="downloadVideo(item)">
							<i class="el-icon-download more-icon" title="下载"></i>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="file-list">
				<div v-if="fileList.length === 0" class="empty-text">暂无文件指南</div>
				<div v-else class="file-items">
					<div v-for="(item, index) in fileList" :key="index" class="file-item" @click="downloadFile(item)">
						<div class="file-icon">
							<img src="@/assets/home/icon_zn_pdf_n@2x.png" alt="pdf" class="icon-img">
						</div>
						<div class="file-info">
							<div class="file-name">{{ item.title }}</div>
						</div>
						<div class="file-action">
							<i class="el-icon-download"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<VideoDialog :visible.sync="dialogVisible" :title="currentVideo.title" :videoUrl="currentVideo.videoUrl" />
	</div>
</template>

<script>
	import VideoDialog from './VideoDialog.vue'

	export default {
		name: 'ReportGuide',
		components: {
			VideoDialog
		},
		data() {
			return {
				activeTab: 'video',
				dialogVisible: false,
				currentVideo: {},
				videoList: [{
						title: '入库上报流程',
						videoUrl: require('@/assets/video/ware/ware.mp4')
					},
					{
						title: '出库上报流程',
						videoUrl: require('@/assets/video/outbou/outbou.mp4')
					},
					{
						title: '发票上报流程',
						videoUrl: require('@/assets/video/invoices/invoices.mp4')
					},
					{
						title: '发票备案说明',
						videoUrl: require('@/assets/video/invoiceba/invoiceba.mp4')
					},
					{
						title: '寄售上报流程',
						videoUrl: require('@/assets/video/outbou/outbou2.mp4')
					},
					{
						title: '库存对账上报流程',
						videoUrl: require('@/assets/video/inventory/inventory.mp4')
					}
				],
				fileList: [{
						title: '归创通桥数据上报系统-操作手册20251228',
						fileName: '归创通桥数据上报系统-操作手册20251228.pdf',
						fileUrl: require('@/assets/pdf/归创通桥数据上报系统-操作手册20251228.pdf')
					},
					{
						title: '未通过再次校验发票(红冲)处理流程260106',
						fileName: '未通过再次校验发票(红冲)处理流程260106.pdf',
						fileUrl: require('@/assets/pdf/未通过再次校验发票(红冲)处理流程260106.pdf')
					},
					{
						title: '鸿雁数据指南-简易版',
						fileName: '鸿雁数据指南-简易版.pdf',
						fileUrl: require('@/assets/pdf/鸿雁数据指南-简易版.pdf')
					}
				]
			}
		},
		methods: {
			playVideo(item) {
				this.currentVideo = item;
				this.dialogVisible = true;
			},
			downloadVideo(item) {
				const link = document.createElement('a');
				link.href = item.videoUrl;
				link.download = item.title + '.mp4';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			downloadFile(item) {
				const link = document.createElement('a');
				link.href = item.fileUrl;
				link.download = item.fileName;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
</script>

<style lang="less" scoped>
	.report-guide {
		width: 780px;
		height: 100%;
		background: #FFFFFF;
		border-radius: 4px;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.banner {
			position: relative;
			width: 100%;
			height: 180px;
			margin-bottom: 20px;
			border-radius: 8px;
			overflow: hidden;

			.bg-img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			.banner-content {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				text-align: center;
				color: #FFFFFF;

				.title {
					font-size: 32px;
					font-weight: bold;
					margin-bottom: 10px;
					text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
				}

				.subtitle {
					display: inline-block;
					padding: 6px 20px;
					border: 1px solid rgba(255, 255, 255, 0.6);
					border-radius: 20px;
					font-size: 14px;
					background: rgba(255, 255, 255, 0.1);
				}
			}
		}

		.tabs {
			display: flex;
			justify-content: center;
			border-bottom: 1px solid #EAECEF;
			margin-bottom: 20px;

			.tab-item {
				font-size: 16px;
				color: #999999;
				padding: 0 40px 15px;
				cursor: pointer;
				position: relative;
				font-weight: 500;

				&.active {
					color: #E71D43;
					font-weight: bold;
				}

				.indicator {
					position: absolute;
					bottom: 0;
					left: 50%;
					transform: translateX(-50%);
					width: 60px;
					height: 3px;
					background: #E71D43;
					border-radius: 2px;
				}
			}
		}

		.content-wrapper {
			padding: 0 20px;
			flex: 1;
			overflow-y: auto;

			&::-webkit-scrollbar {
				width: 6px;
			}

			&::-webkit-scrollbar-thumb {
				background: #ccc;
				border-radius: 3px;
			}

			&::-webkit-scrollbar-track {
				background: transparent;
			}

			.video-list {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.video-item {
					width: 350px;
					margin-bottom: 20px;
					background: #F7F8FA;
					border-radius: 8px;
					overflow: hidden;
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
					}

					.video-cover {
						width: 100%;
						height: 180px;
						background-color: #d8d8d8;
						display: flex;
						justify-content: center;
						align-items: center;
						position: relative;
						overflow: hidden;

						.preview-video {
							width: 100%;
							height: 100%;
							object-fit: cover;
						}

						.play-btn {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							width: 50px;
							height: 50px;
							background: rgba(255, 255, 255, 0.2);
							border-radius: 50%;
							display: flex;
							justify-content: center;
							align-items: center;
							backdrop-filter: blur(4px);

							i {
								color: #FFF;
								font-size: 24px;
							}
						}
					}

					.video-info {
						padding: 12px 15px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.video-title {
							font-size: 16px;
							color: #333333;
							font-weight: 500;
						}

						.more-icon {
							color: #999999;
							font-size: 18px;
							font-weight: bold;
							transition: color 0.3s;
						}

						.more-actions {
							position: relative;
							cursor: pointer;
							padding: 5px;

							&:hover .more-icon {
								color: #E71D43;
							}
						}
					}
				}
			}

			.file-list {
				display: flex;
				justify-content: center;
				/* align-items: center; */
				min-height: 300px;
				color: #999;

				.empty-text {
					margin-top: 100px;
				}

				.file-items {
					display: flex;
					flex-direction: column;
					gap: 15px;
					width: 100%;
					padding-top: 10px;
				}

				.file-item {
					display: flex;
					align-items: center;
					padding: 15px 20px;
					background: #F7F8FA;
					border-radius: 8px;
					cursor: pointer;
					transition: all 0.3s;

					&:hover {
						background: #EFF1F4;
						transform: translateY(-2px);
						box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
					}

					.file-icon {
						width: 40px;
						height: 40px;
						/* background: #FFECEC; */
						border-radius: 8px;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-right: 15px;

						.icon-img {
							width: 100%;
							height: 100%;
							object-fit: contain;
						}
					}

					.file-info {
						flex: 1;

						.file-name {
							font-size: 16px;
							color: #333;
							font-weight: 500;
						}
					}

					.file-action {
						color: #999;
						font-size: 20px;
						transition: color 0.3s;
					}

					&:hover .file-action {
						color: #E71D43;
					}
				}
			}
		}
	}
</style>